// @flow
import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import navItems from "root/routes/navItems";
import LocalTab from "tabs/Local";
import { getLogger } from "@cld/upload-widget";
import DevAuthFlow from "root/components/DevAuthFlow/DevAuthFlow";
import { selectDefaultSource } from "../../selectors";

type OwnProps = {|
    route: Object
|};

type Props = {
    ...OwnProps,
    defaultSource: string
};

const logger = getLogger();

const getNavItemForConfigDefault = (items: Object[], defaultSrc: string) => (items.find((i) => (i.id === defaultSrc))) || items[0];

const getShouldRedirectDefault = (props: Props) => (props.defaultSource &&
	props.defaultSource !== props.route.match &&
	props.route.match.isExact);

export const DefaultPanel = (props: Props) => {
	let result;

	if (~window.location.search.indexOf("authFlow=true")) { // this is for DEV only. in Production we go through /auth/index.html
		result = <DevAuthFlow />;
	} else if (getShouldRedirectDefault(props)) {
		const defaultItem = getNavItemForConfigDefault(navItems, props.defaultSource);
		logger.log(`[DefaultPanel]: redirecting to default panel with path: ${defaultItem.path}`);

		result = <Redirect to={defaultItem.path} />;
	} else {
		result = <LocalTab route={props.route} />; // always render files tab for the file input field to be rendered
	}

	return result;
};

export default connect<Props, OwnProps, _, _, _, _>(selectDefaultSource)(DefaultPanel);
